import { isMuted, setMuted } from '../audio/audio';
import type { Radio } from '../audio/radio/radio';
import { isTyping } from '../core/input/keyboard';

/** Keys that work everywhere, not just while driving: M mutes, R / Shift+R change station, T plays or pauses the radio. */
export function bindHotkeys(radio: Radio): void {
  window.addEventListener('keydown', (e) => {
    if (isTyping(e.target)) return;
    if (e.code === 'KeyM') {
      setMuted(!isMuted());
      radio.setMuted(isMuted());
    }
    if (e.code === 'KeyR') {
      if (e.shiftKey) radio.prev();
      else radio.next();
    }
    if (e.code === 'KeyT' && !e.repeat) radio.togglePause();
  });
}
